import { defineFcm } from '../shared/factory';

export const FCM_ADVOCATES_PSF_TASKS = defineFcm('advocates_psf_tasks').asString().withDefault(undefined).toConfig();
